import { Col, Container, Row, Text } from '@qonsoll/react-design'

import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'

export default function StoreStoreStatus(props) {
  const { status } = props

  /* Getting translation instance */
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {status ? (
            <Text>{status}</Text>
          ) : (
            <Text type="secondary" variant="overline">
              {t('No store statuses have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

StoreStoreStatus.propTypes = {
  status: PropTypes.string.isRequired
}
